import { render, staticRenderFns } from "./consultationAcademician.vue?vue&type=template&id=6cd77c2c&"
import script from "./consultationAcademician.vue?vue&type=script&lang=js&"
export * from "./consultationAcademician.vue?vue&type=script&lang=js&"
import style0 from "./consultationAcademician.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports